import { useEffect, useState } from 'react';
import axios from 'axios';
import C from '../../constants/palette';

function normalizeStatus(value) {
  const status = String(value || '').toUpperCase();
  if (['PAID', 'SUCCESS', 'SUCCEEDED', 'COMPLETED'].includes(status)) return 'PAID';
  if (['FAILED', 'FAIL', 'ERROR'].includes(status)) return 'FAILED';
  if (['CANCELLED', 'CANCELED'].includes(status)) return 'CANCELLED';
  return 'PENDING';
}

export default function PaymentResultPage({ onBack }) {
  const params = new URLSearchParams(window.location.search);
  const paymentId = params.get('paymentId') || '';
  const [status, setStatus] = useState(normalizeStatus(params.get('status')));
  const [loading, setLoading] = useState(Boolean(paymentId));

  useEffect(() => {
    if (!paymentId) return;
    axios.get(`/api/payments/${paymentId}/status`)
      .then(res => setStatus(normalizeStatus(res.data.status)))
      .finally(() => setLoading(false));
  }, [paymentId]);

  const paid = status === 'PAID';
  const failed = status === 'FAILED' || status === 'CANCELLED';

  return (
    <div style={{ minHeight: '100vh', background: '#F8F9FA', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32 }}>
      <div style={{ width: '100%', maxWidth: 520, background: '#fff', border: `1px solid ${C.border}`, padding: 48, textAlign: 'center' }}>
        <p style={{ fontSize: 10, letterSpacing: '0.22em', color: C.gold, fontWeight: 700, marginBottom: 18 }}>
          PAYMENT {loading ? 'CHECKING' : status}
        </p>
        <h1 style={{ fontFamily: 'Playfair Display', fontSize: 40, fontWeight: 400, color: C.ink, marginBottom: 18 }}>
          {loading && 'Checking Payment'}
          {!loading && paid && 'Acquisition Confirmed'}
          {!loading && failed && 'Payment Not Completed'}
          {!loading && !paid && !failed && 'Payment Pending'}
        </h1>
        <p style={{ fontSize: 14, color: C.muted, lineHeight: 1.8, marginBottom: 32 }}>
          {loading && 'We are confirming the payment status with the gateway.'}
          {!loading && paid && 'Your payment has been confirmed. The treasure is now marked sold and the transaction record has been created.'}
          {!loading && failed && 'The payment was not completed. The treasure remains available.'}
          {!loading && !paid && !failed && 'We have not received final confirmation yet. Please check again shortly.'}
        </p>
        {paymentId && (
          <p style={{ fontFamily: 'DM Mono', fontSize: 11, color: C.muted, marginBottom: 28 }}>
            PAYMENT ID {paymentId}
          </p>
        )}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap' }}>
          {paymentId && (
            <button onClick={() => { window.history.pushState(null, '', `/track?trackingId=${encodeURIComponent(paymentId)}`); window.dispatchEvent(new Event('popstate')); }} style={{
              padding: '13px 24px',
              background: '#fff',
              border: `1px solid ${C.border}`,
              cursor: 'pointer',
              fontSize: 11,
              letterSpacing: '0.16em',
              fontWeight: 700,
              color: C.ink,
            }}>
              TRACK TRANSACTION
            </button>
          )}
          <button onClick={onBack} style={{
            padding: '13px 32px',
            background: C.gold,
            border: 'none',
            cursor: 'pointer',
            fontSize: 11,
            letterSpacing: '0.16em',
            fontWeight: 700,
            color: C.dark,
          }}>
            RETURN TO COLLECTION
          </button>
        </div>
      </div>
    </div>
  );
}
